module.exports = __webpack_public_path__ + "74476d6065146a40e03ae857d4313e0e.glb";